import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const sendErrorStyles = StyleSheet.create({
	banner: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '8px 12px',
		backgroundColor: THEME.colors.warning.light,
		border: `1px solid ${THEME.colors.warning.main}`,
		borderRadius: '4px',
		fontSize: '13px',
		color: THEME.colors.warning.dark,
		margin: '4px 0',
	},
	dismissBtn: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		fontSize: '16px',
		color: THEME.colors.warning.dark,
		padding: '0 4px',
	},
});
